import React from 'react';
import { Add, Edit, Delete } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Col, Row } from 'antd';
import { map, get } from 'lodash';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
import ExamCover from 'components/AdminBooks/ExamCover';
import Section from 'components/Section';

const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;

const ListItem = styled.li`
    margin: 0px 4% 32px;
    width: calc(21%);

    @media only screen and (min-width: 600px) and (max-width: 800px) {
        margin: 0px 16px 32px;
        width: calc(50% - 32px);
    }

    @media only screen and (max-width: 600px) {
        flex-direction: column;
        margin: 0px 16px 32px;
        width: 100%;
    }
`;

const List = styled.ul`
    height: auto;
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style-type: none;
    justify-content:center;
`;

const ExamList = ({
  examDatam,
  onAddExam,
  onAddEditExamLevel,
  setOpenDeleteExamModal,
  setActiveData
}) => {
  return (
    <Row style={{ marginTop: '1%' }}>
      <Col xs={{ span: 24 }} lg={{ span: 24 }}>
        <Section
          style={{ fontSize: '18px' }}
          description="exams and standard based exams"
          header="Exams & Standard Based Exams"
        >
          {map(examDatam, (exm) => {
            const isStandardExam = exm.exam_school === 'standard';
            return (
              <LinkArea key={exm.id}>
                <Row>
                  <Col span={18}>
                    <Button
                      onClick={() => onAddExam(exm)}
                      color="primary"
                      variant="contained"
                    >
                      <Add /> exams
                    </Button>
                    <Button
                      onClick={() => {
                        onAddEditExamLevel(exm);
                      }}
                      color="primary"
                      variant="contained"
                      style={{ marginLeft: '10px' }}
                    >
                      <Edit /> Edit{' '}
                      {isStandardExam ? 'Standard Based Exam' : 'Exam Level'}
                    </Button>
                    <Button
                      onClick={() => {
                        setOpenDeleteExamModal(true);
                        setActiveData(exm);
                      }}
                      color="secondary"
                      variant="contained"
                      style={{ marginLeft: '10px' }}
                    >
                      <Delete style={{ color: 'white' }} /> {isStandardExam ? 'Standard Based Exam' : 'Exam Level'}
                    </Button>
                  </Col>
                  <Col span={6}>
                    <span style={{ 
                      display: 'inline-block', 
                      textAlign: 'right', 
                      fontWeight: 600, 
                      fontSize: '14px',
                      padding: '8px 16px',
                      color: '#ffffff',
                      backgroundColor: '#9c27b0',
                      borderRadius: '20px',
                      marginRight: '16px',
                      float: 'right',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
                    }}>
                      {exm.displayName || ''}
                    </span>
                  </Col>
                </Row>
                <Row style={{ marginTop: '1%' }}>
                  <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                    {!exm.exams || exm.exams.length === 0 ? (
                      <div style={{ 
                        textAlign: 'center', 
                        padding: '40px 20px',
                        border: '1px dashed #ddd',
                        borderRadius: '8px',
                        backgroundColor: '#f9f9f9'
                      }}>
                        <p style={{ 
                          fontSize: '16px', 
                          color: '#666', 
                          marginBottom: '20px',
                          fontStyle: 'italic'
                        }}>
                          No exams found. Add your first exam to get started.
                        </p>
                        <Button
                          onClick={() => onAddExam(exm)}
                          color="primary"
                          variant="contained"
                        >
                          <Add /> exams
                        </Button>
                      </div>
                    ) : (
                      <List>
                        {map(exm.exams, (obj, i) => (
                          <ListItem key={obj.id}>
                            <ExamCover
                              data={obj}
                              handleClick={() => onAddExam(exm, obj)}
                              labelBgColor={isStandardExam ? COLOR.blue : COLOR.redishpink}
                              label={get(exm, 'displayName')}
                              exam={exm}
                            />
                          </ListItem>
                        ))}
                      </List>
                    )}
                  </Col>
                </Row>
              </LinkArea>
            );
          })}
        </Section>
      </Col>
    </Row>
  );
};

export default ExamList;
